import { render, staticRenderFns } from "./ConfirmToms.vue?vue&type=template&id=100dc620&scoped=true"
import script from "./ConfirmToms.vue?vue&type=script&lang=js"
export * from "./ConfirmToms.vue?vue&type=script&lang=js"
import style0 from "./ConfirmToms.vue?vue&type=style&index=0&id=100dc620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100dc620",
  null
  
)

export default component.exports